<template>
    <div class="pphistory">
         <div class="menu">
            <el-form :inline="true" >
               <el-form-item label="选择支线">
                <el-select placeholder="请选择支线" v-model="pipelineId" @change="changePipelineId">
                    <el-option label="耕德电子站点侧支线" value="1"></el-option>
                    <el-option label="顶益400支线" value="2"></el-option>
                    <el-option label="娃哈哈200支线" value="3"></el-option>
                    <el-option label="味全食品支线" value="4"></el-option>
                    <el-option label="耕德电子测点间支线" value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-button plain type="primary" class="menu-btn" @click="presetTime('day')">一天
              </el-button>
              <el-button plain type="primary" class="menu-btn" @click="presetTime('week')">
                一周
              </el-button>
              <el-button plain type="primary" class="menu-btn" @click="presetTime('month')">
                一个月
              </el-button>
              <el-button plain type="primary" class="years menu-btn" @click="presetTime('year')">
                一年
              </el-button>

              <el-form-item label="开始时间">
                <!--日期-->
                <el-date-picker
                  v-model="start_time"
                  type="datetime"
                  class="start_date date-input"
                  placeholder="开始时间">
                </el-date-picker>
              </el-form-item>
      
              <el-form-item label="结束时间">
                <!--日期-->
                <el-date-picker
                  v-model="end_time"
                  type="datetime"
                  class="end_date date-input"
                  placeholder="结束时间">
                </el-date-picker>
              </el-form-item>

              <el-button plain type="primary" class="menu-btn" @click="searchData()">
                <span>查询</span>
              </el-button>
            </el-form>
        </div>
        <div class="condition-wrap">
            <div class="condition">
                <el-checkbox v-model="velocity.checked">流速</el-checkbox>
                <el-input v-model="velocity.min" placeholder="请输入内容" type="number"></el-input>
            </div>
            <div class="condition">
                <el-checkbox v-model="overHeat.checked">过热度</el-checkbox>
                <el-input v-model="overHeat.min" placeholder="请输入内容" type="number"></el-input>
            </div>
            <div class="condition">
                <el-checkbox v-model="hLoss.checked">温降</el-checkbox>
                <el-input v-model="hLoss.min" placeholder="请输入内容" type="number"></el-input>
            </div>
        </div>

        <!--表格-->
        <el-table
        :data="alarmData"
        border
        class="report-table data-table"
        style="width: 100%"
        :max-height="tableHight"
        :header-cell-style="{
            background: 'rgba(78,132,255,1)',
            color: 'white',
            textAlign: 'center',
        }">
            <el-table-column
                prop="id"
                label="ID"
            >
            </el-table-column>
            <el-table-column
                prop="start_time"
                label="开始时间"
            >
            </el-table-column>
            <el-table-column
                prop="end_time"
                label="结束时间"
            >
            </el-table-column>
            <el-table-column
                prop="interval"
                label="时长"
            >
            </el-table-column>
            <el-table-column prop="type">
                <template slot="header">
                    <div>报警类型</div>
                </template>
            </el-table-column>
            <el-table-column prop="cause">
                <template slot="header">
                    <div>报警原因</div>
                </template>
            </el-table-column>
            <el-table-column prop="suggest">
                <template slot="header">
                    <div>建议</div>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <el-pagination v-if="page.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-sizes="[10, 20, 30, 40,100]"
            :page-size="page.size"
            layout="prev, pager, next, jumper,sizes,total"
            :total="page.total">
        </el-pagination>
    </div>
</template>
<script>
import {findAlarmInterval} from "@api/decision"
export default {
    name:"ppalarm",
    data(){
        return {
            pipelineId:"1" , // 管道编号
            start_time:"" , // 开始时间
            end_time:"", // 结束时间

            alarmData:[], // 报警数据
            tableHight:400, // 表格的高度

            page:{ // 分页参数
                total:0,
                size:10,
                current:1
            },

            velocity:{
                min:0,
                checked:true
            }, // 流速选择框
            overHeat:{
                min:0,
                checked:true
            }, // 过热度选择框
            hLoss:{
                min:0,
                checked:true
            }, // 温降选择框

        }
    },
    mounted(){
        this.$nextTick(()=>{
            // 获取页面高度，并设置table高度
            let windowH=window.innerHeight;
            this.tableHight=windowH-170;
        });

        // 获取当前时间，并格式化
        let now=new Date();
        let nowObj=this.$moment(now);
        this.end_time=nowObj.format("yyyy-MM-DD HH:mm:ss");
        this.start_time=nowObj.add(-1,'days').format("yyyy-MM-DD HH:mm:ss");

        // 获取管段历史数据
        this.findAlarmInterval(1,10);
    },
    methods:{
        // 获取管段的历史数据
        findAlarmInterval(){
            let velocity_min=undefined,overHeat_min=undefined,hLoss_min=undefined;

            // 如果流速复选框选中
            if(this.velocity.checked){
                velocity_min=this.velocity.min;
            }
            // 如果过热度复选框选中
            if(this.overHeat.checked){
                overHeat_min=this.overHeat.min;
            }
            // 如果温降过热度复选框选中
            if(this.hLoss.checked){
                hLoss_min=this.hLoss.min;
            }
            findAlarmInterval(this.pipelineId,this.start_time,this.end_time,velocity_min,overHeat_min,hLoss_min).then(res=>{
                if(res.alarmIntervals){
                    this.alarmData=res.alarmIntervals;
                }
            });
        },
        // 管道切换
        changePipelineId(val){
            this.pipelineId=val;
            this.findAlarmInterval();
        },

        // 查询报警数据
        searchData(){
            this.findAlarmInterval();
        },
        // 页码改变
        handleCurrentChange(val){
            console.log(val);
        },
        // 分页大小改变
        handleSizeChange(val){
            console.log(val);
        },
        // 预设事件段
        presetTime(type){
            let now=new Date();
            let nowObj=this.$moment(now);
            this.end_time=nowObj.format("yyyy-MM-DD HH:mm:ss");
            switch(type){
                case "day":
                    this.start_time=nowObj.add(-1,'days').format("yyyy-MM-DD HH:mm:ss");
                    break;
                case "week":
                    this.start_time=nowObj.add(-1,'weeks').format("yyyy-MM-DD HH:mm:ss");
                    break;
                case "month":
                    this.start_time=nowObj.add(-1,'months').format("yyyy-MM-DD HH:mm:ss");
                    break;
                case "year":
                    this.start_time=nowObj.add(-1,'years').format("yyyy-MM-DD HH:mm:ss");
                    break;
            }
            // 查询数据
            this.findAlarmInterval();
        },
    }
    
}
</script>
<style lang="scss">
.pphistory{
    padding:10px;

    button{
        cursor: pointer;
        span{
            cursor: pointer;
        }
    }
    .years{
        margin-right: 10px;
    }

    .el-pagination{
        float:right;
    }
    .el-form-item{
        margin-bottom:10px;
    }

    .condition-wrap{
        .condition{
            display: inline-block;
            border:1px solid #7cc2f1;
            border-radius: 4px;
            font-size: 26px;
            padding:5px 10px;
            line-height: 25px;
            margin-right: 10px;
            margin-bottom: 10px;
        }
        /**输入框 */
        .el-input{
            width:50px;
            margin-left: 5px;
            .el-input__inner{
                padding:0 4px;
                text-align: center;
            }
        }
        /**多选框 */
        .el-checkbox__inner{
            height: 20px;
            width: 20px;
        }
        /**选择框的对号图标 */
        .el-checkbox__inner::after{
            top:4px;
            left: 8px;
        }
    }
    .data-table{
        td,th{
            text-align: center !important;
        }
    }
}
</style>